import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'sonner'
import { usePlatformAuth } from '@/hooks/usePlatformAuth'

/** Login del administrador de plataforma (separado del login de tenant). */
export default function PlatformLoginPage() {
    const navigate = useNavigate()
    const { login } = usePlatformAuth()
    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')
    const [mfaCode, setMfaCode] = useState('')
    const [mfaRequired, setMfaRequired] = useState(false)
    const [loading, setLoading] = useState(false)

    const onSubmit = async (e: React.FormEvent) => {
        e.preventDefault()
        setLoading(true)
        try {
            await login(username, password, mfaRequired ? mfaCode : undefined)
            toast.success('Sesión de plataforma iniciada')
            navigate('/platform/dashboard', { replace: true })
        } catch (err: any) {
            if (err?.mfaRequired) {
                setMfaRequired(true)
                toast.message('Ingresa el código de tu app de autenticación')
            } else {
                toast.error('Credenciales inválidas')
            }
        } finally {
            setLoading(false)
        }
    }

    return (
        <div className="flex min-h-screen items-center justify-center bg-slate-900 px-4">
            <form onSubmit={onSubmit}
                className="w-full max-w-sm space-y-5 rounded-xl border border-slate-700 bg-slate-800 p-8 shadow-xl">
                <div className="text-center">
                    <h1 className="text-xl font-semibold text-slate-100">VANTAK · Plataforma</h1>
                    <p className="mt-1 text-sm text-slate-400">Administración del sistema</p>
                </div>
                <div>
                    <label className="mb-1 block text-sm text-slate-300">Usuario</label>
                    <input value={username} onChange={(e) => setUsername(e.target.value)} autoComplete="username"
                        className="w-full rounded-md border border-slate-600 bg-slate-900 px-3 py-2 text-slate-100 outline-none focus:border-indigo-500" />
                </div>
                <div>
                    <label className="mb-1 block text-sm text-slate-300">Contraseña</label>
                    <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password"
                        className="w-full rounded-md border border-slate-600 bg-slate-900 px-3 py-2 text-slate-100 outline-none focus:border-indigo-500" />
                </div>
                {mfaRequired && (
                    <div>
                        <label className="mb-1 block text-sm text-slate-300">Código MFA (6 dígitos)</label>
                        <input value={mfaCode} onChange={(e) => setMfaCode(e.target.value)} inputMode="numeric" maxLength={6} autoFocus
                            className="w-full rounded-md border border-slate-600 bg-slate-900 px-3 py-2 text-center font-mono tracking-widest text-slate-100 outline-none focus:border-indigo-500" />
                    </div>
                )}
                <button type="submit" disabled={loading}
                    className="w-full rounded-md bg-indigo-600 py-2 font-medium text-white hover:bg-indigo-500 disabled:opacity-60">
                    {loading ? 'Ingresando…' : 'Ingresar'}
                </button>
            </form>
        </div>
    )
}
